import React, { useState } from 'react';

type UseFormQuantityReturn = {
    quantity: number;
    oldQuantity: number;
    onReset: () => void;
    onInputChange: (e: React.ChangeEvent<HTMLInputElement>, minValue: number, maxValue?: number) => void;
    setQuantity: React.Dispatch<React.SetStateAction<number>>;
};

export const useFormQuantity = (initialQuantity: number): UseFormQuantityReturn => {
    const [quantity, setQuantity] = useState<number>(initialQuantity);

    const onReset = () => {
        setQuantity(oldQuantity);
    };

    const onInputChange = (e: React.ChangeEvent<HTMLInputElement>, minValue: number, maxValue?: number) => {
        const newValue = parseInt(e.target.value);

        // Avoid adding 0 at the beginning
        if (e.target.value.charAt(0) === '0') {
            e.target.value = String(newValue);
        }

        // If anything below minValue keep minValue
        if (!newValue || newValue <= minValue) {
            setQuantity(minValue);
            e.target.value = String(minValue);
            return;
        }

        // Max value
        if (maxValue && newValue >= maxValue) {
            setQuantity(maxValue);
            e.target.value = String(maxValue);
            return;
        }

        if (e.target.value.length <= 0) {
            setQuantity(0);
        } else {
            setQuantity(newValue);
        }
    };

    const oldQuantity = initialQuantity;

    return { quantity, oldQuantity, onReset, onInputChange, setQuantity };
};
